import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AnimatePresence, motion } from 'framer-motion';
import { useFitnessStore } from '../../store/fitnessStore';
import BottomNav from './nav/BottomNav';
import HomeScreen from './screens/HomeScreen';
import WorkoutScreen from './screens/WorkoutScreen';
import NutritionScreen from './screens/NutritionScreen';
import SportScreen from './screens/SportScreen';
import WellnessScreen from './screens/WellnessScreen';
import ProgressScreen from './screens/ProgressScreen';
import ProfileScreen from './screens/ProfileScreen';
import ExerciseModal from './modals/ExerciseModal';
import UpgradeModal from './modals/UpgradeModal';
import PlanModal from './modals/PlanModal';
import '../../styles/fitness.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 1000 * 60 * 5 } } });

const SCREENS = {
  home: HomeScreen,
  workout: WorkoutScreen,
  nutrition: NutritionScreen,
  sport: SportScreen,
  wellness: WellnessScreen,
  progress: ProgressScreen,
  profile: ProfileScreen,
};

function AppContent() {
  const activeScreen = useFitnessStore((s) => s.activeScreen);
  const Screen = SCREENS[activeScreen] || HomeScreen;

  return (
    <div className="fit-root" style={{ position: 'relative', minHeight: '100vh', paddingBottom: 80 }}>
      <AnimatePresence mode="wait">
        <motion.div
          key={activeScreen}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          <Screen />
        </motion.div>
      </AnimatePresence>
      <BottomNav />
      <ExerciseModal />
      <UpgradeModal />
      <PlanModal />
    </div>
  );
}

export default function FitnessApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
    </QueryClientProvider>
  );
}
